import React, { useState, useEffect } from "react";
import { Link, matchPath, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from '@mui/material/styles';

import Drawer from "@mui/material/Drawer";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Logout } from "@mui/icons-material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';


// import Logo from "../../../assets/images/logo.svg";
import Logo from "../../../assets/images/cc_logo.png";
import CloudContentLogo from "../../../assets/images/cc_logo_dark.png";


import ContentModel from "../../../assets/images/Content_model.svg";
import Content from "../../../assets/images/Content.svg";
// import Media from "../../../assets/images/Media.svg";
import MediaIcon from "../../../components/icons/MediaIcon";
import SettingsIcon from "../../../components/icons/SettingsIcon";
import ContentIcon from "../../../components/icons/ContentIcon";
import ContentModelIcon from "../../../components/icons/ContentModelIcon";
import WorkspaceIcon from "../../../components/icons/WorkspaceIcon";


import ProfileIcon from "../../../assets/images/profile_circle.png";
// import WorkspaceIcon from "../../../assets/images/Workspaces.svg"
import AuthLogout from "../../../pages/authentication/auth-forms/AuthLogout";

import { Card, Grid2, CardMedia, Stack, Box } from "@mui/material";
import { useParams } from 'react-router-dom';

const drawerWidth = 240;

const DrawerLayout = () => {
  const dispatch = useDispatch();
  const { workspaceId } = useParams();
  const location = useLocation();

  const currentUser = JSON.parse(localStorage.getItem('userInfo'));

  const name = currentUser?.name ? currentUser?.name?.split(' ')[0] : '';
  const useremail = currentUser?.email ? currentUser?.email : '';
  const avatarUrl = currentUser?.avatarUrl || ProfileIcon;
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    console.log("Logout clicked");
    // Add your logout logic here
    handleMenuClose();
  };


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuItemClick = () => {
    if (isMobile) {
      handleDrawerToggle();
    }
  };

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };



  const menuItems = [
    {
      text: "Content model",
      icon: <ContentModelIcon />,
      path: `/${workspaceId}/content-models`,
    },
    {
      text: "Content",
      icon: <ContentIcon />,
      path: `/${workspaceId}/entries`,
    },
    {
      text: "Media",
      icon: <MediaIcon />,
      path: `/${workspaceId}/media-list`,
    },
    {
      text: "Settings",
      icon: <SettingsIcon />,
      path: `/${workspaceId}/settings`,
    },
  ];

  const primaryMenuItems = [
    {
      text: "Workspace",
      icon: <WorkspaceIcon />,
      path: `/space`,
    },
    {
      text: "Apps",
      icon: <ContentIcon />,
      path: `/apps`,
    },

  ];

  const drawer = (
    <>
      <Grid2 spacing={2} sx={{ background: 'white' }}>
        <Grid2
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: isCollapsed ? 2 : 4,
            width: "100%",
            paddingTop: 2,
            margin: "0 auto",
          }}
        >
          {!isCollapsed && (
            <img
              src={CloudContentLogo}
              width={150}
              alt=""
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            />
          )}
          {
            !isMobile && <IconButton
              onClick={handleCollapse}
              sx={{
                float: 'right',
                color: '#245DAD',
                transition: 'transform 0.3s ease',
                margin: 1
              }}
            >{isCollapsed ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
            </IconButton>
          }


        </Grid2>
        <Grid2 size={12}>
          <Divider
            sx={{ backgroundColor: "#fff", width: "90%", margin: "0 auto" }}
          />

          <List>
            {location.pathname === '/space' || location.pathname === '/apps' ?
              primaryMenuItems.map((item, index) => {
                const isSelected = location.pathname === item.path;
                return (
                  <ListItem
                    key={item.text}
                    component={Link}
                    to={item.path}
                    selected={isSelected}
                    sx={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      backgroundColor: isSelected ? "rgba(112, 190, 253, 0.42)" : "#fff",
                      justifyContent: isCollapsed ? 'center' : 'flex-start',
                      borderRadius: 2,
                      marginLeft: 1,
                      marginRight: 1
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: isSelected ? "#245dad" : "#0D0D0D",
                        minWidth: isCollapsed ? 'auto' : 36
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    {!isCollapsed && (
                      <ListItemText sx={{
                        color: isSelected ? "#245dad" : "#0D0D0D",
                      }} primary={item.text} />
                    )}
                  </ListItem>
                );
              })
              :
              menuItems.map((item, index) => {
                const isSelected = location.pathname === item.path;
                return (
                  <ListItem
                    key={item.text}
                    component={Link}
                    to={item.path}
                    onClick={handleMenuItemClick}
                    selected={isSelected}
                    sx={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      backgroundColor: isSelected ? "rgba(112, 190, 253, 0.42)" : "#fff",
                      justifyContent: isCollapsed ? 'center' : 'flex-start',
                      borderRadius: 2,
                      marginLeft: 1,
                      marginRight: 1
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: isSelected ? "#245dad" : "#0D0D0D",
                        minWidth: isCollapsed ? 'auto' : 36
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    {!isCollapsed && (
                      <ListItemText sx={{
                        color: isSelected ? "#245dad" : "#0D0D0D",
                      }} primary={item.text} />
                    )}
                  </ListItem>
                );
              })
            }

          </List>
        </Grid2>
      </Grid2>
      <Grid2 container size={12}>
        <Grid2>
          {(location.pathname !== '/space' && location.pathname !== '/apps') &&
            <ListItem
              component={Link}
              to='space'
              //  selected={true}
              onClick={handleMenuItemClick}
              sx={{
                paddingTop: 2,
                paddingBottom: 2
              }}
            >
              <ListItemIcon
                sx={{ color: "#000000", justifyContent: isCollapsed ? 'center' : 'flex-start', }}
              >
                <WorkspaceIcon />

              </ListItemIcon>
              {!isCollapsed && (
                <ListItemText sx={{
                  color: "#0D0D0D",
                }} primary='Workspaces' />
              )}
            </ListItem>
          }
        </Grid2>
        <Grid2 size={12}>
          <Divider
            sx={{ backgroundColor: "#fff", width: "90%", margin: "0 auto" }}
          />
          <Grid2 >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: { xs: 0, md: 2 },
              }}
            >
              {/* Avatar and Name */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar alt={name} src={avatarUrl} />
                {!isCollapsed && <Typography variant="body1" fontWeight="bold">
                  {name}
                </Typography>}

              </Box>

              {/* More Options */}
              <IconButton onClick={handleMenuClick}>
                <MoreVertIcon />
              </IconButton>

              {/* Dropdown Menu */}
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{
                  boxShadow:
                    'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
                  '& .MuiMenu-list': {
                    padding: '4px 0',
                  }
                }}
              >
                <MenuItem sx={{ backgroundColor: '#e5e7eb', borderRadius: '8px' }}>
                  <AuthLogout>
                    <Stack alignItems="center">
                      {isCollapsed ? (
                        <Logout sx={{ color: 'black' }} />
                      ) : (
                        <Typography variant="p" color="#0D0D0D" sx={{ cursor: 'pointer' }}>
                          Log out
                        </Typography>
                      )}

                    </Stack>
                  </AuthLogout>
                </MenuItem>
              </Menu>
            </Box>

            {/* <Stack alignItems="center" spacing={2.5}>
           
              <CardMedia
                component="img"
                image={avatarUrl}
                sx={{ width: 30 , borderRadius:25}}
              />
              <Stack alignItems="center">
                <Typography variant="p" color="#0D0D0D">
                  {name}
                </Typography>
              </Stack>
              <AuthLogout>
                <Stack alignItems="center">
                  {isCollapsed ? (
                    <Logout sx={{ color: 'white' }} />
                  ) : (
                    <Typography variant="p" color="#0D0D0D" sx={{ cursor: 'pointer' }}>
                      Log out
                    </Typography>
                  )}

                </Stack>
              </AuthLogout>
            </Stack> */}
          </Grid2>
        </Grid2>
      </Grid2 >
    </>
  )

  return (
    <>
      {isMobile && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            position: 'fixed',
            left: 16,
            top: 16,
            borderRadius: 2,
            zIndex: 1300,
            background: 'linear-gradient(90deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)',
            color: '#fff',
            '&:hover': {
              bgcolor: '#6c4e96'
            }
          }}
        >
          <MenuIcon />
        </IconButton>
      )}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        sx={{
          width: isCollapsed ? 85 : drawerWidth,
          flexShrink: 0,
          zIndex: 1200,
          [`& .MuiDrawer-paper`]: {
            width: isCollapsed ? 85 : drawerWidth,
            boxSizing: "border-box",
            // background: 'linear-gradient(90deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)',
            justifyContent: "space-between",
            transition: 'width 0.3s ease'
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default DrawerLayout;
